export default __webpack_public_path__ + "2906474d5e01cef1e754c991c8289f60.jpg";